module.exports = __webpack_public_path__ + "static/media/galleryImg20.eca5fac2.jpg";